import {Request} from '../shared/base.requests'
import config from '../../config/customer.api'
/* eslint-disable */
const aboutModule = {
  namespaced: true,
  state: {
    facebookDeepLink: '',
    aboutData: {
      videoUrl: '',
      salesImageModels: []
    },
    aboutUsData: {
      dealerPhotos: [],
      socialLinks: []
    },
    pagesEnum: {
      Media: 1,
      Bio: 2,
      Socials: 3
    },
    SocialNameEnum: {
      google: 0,
      ginkedin: 1,
      facebook: 2,
      twitter: 3,
      pinterest: 4,
      linkedin: 5
    },
    page: 1
  },
  mutations: {
    setAboutData (state, payload) {
      state.aboutData = payload
    },
    setFacebookDeepLing (state, payload) {
      state.facebookDeepLink = payload
    },
    setAboutUsData (state, payload) {
      state.aboutUsData = payload
    },
    setPage (state, payload) {
      state.page = payload
    }
  },
  actions: {
    setAboutData: function (context, data) {
      context.commit('setAboutData', data)
    },
    getAboutUsData: function (context) {
      return new Promise((resolve, reject) => {
        context.dispatch('setPageAbout', 1)
        Request.GetFromCache(config.getAboutUsData, function (json) {
          if (json.success) { context.commit('setAboutUsData', json.model) }
          resolve()
        })
        Request.get(config.getAboutUsData).then(result => {
          if (result.success) { context.commit('setAboutUsData', result.model) }
          resolve()
        }).catch(function () {
          console.log('error loading about data')
          reject()
        })
      })
    },
    getAboutData: function (context) {
      return new Promise((resolve, reject) => {
        Request.GetFromCache(config.getHomePageSettings, function (json) {
          context.commit('setAboutData', json)
          resolve()
        })
        Request.get(config.getAboutData).then(result => {
          context.commit('setAboutData', result)
          resolve()
        }).catch(function () {
          console.log('error loading about data')
          reject()
        })
      })
    },
    getFacebookDeepLink: function (context) {
      return new Promise((resolve, reject) => {
        console.log(context.state);
        Request.GetFromCache(config.getFacebookDeepLink + "?pageID=" + context.state.aboutUsData.socialLinks[context.state.SocialNameEnum.facebook].value, function (json) {
          context.commit('setFacebookDeepLing', json.model)
          resolve()
        })
        Request.get(config.getFacebookDeepLink + "?pageID=" + context.state.aboutUsData.socialLinks[context.state.SocialNameEnum.facebook].value).then(result => {
          context.commit('setFacebookDeepLing', result.model)
          resolve()
        }).catch(function () {
          console.log('error loading facebook deep link')
          context.commit('setFacebookDeepLing', "")
          resolve()
        })
      })
    },
    setPageAbout: function (context, payload) {
      context.commit('setPage', payload)
    }
  },
  getters: {
    getAbout: state => {
      return state.aboutData
    }
  }
}

export default aboutModule



// WEBPACK FOOTER //
// ./scripts/src/store/about.module.js